import { ReactElement } from 'react';
import { Typography, Button } from 'antd';
import { SiteName, NavigationMenu, NavLink, LogoutButton, HeaderBlock } from './styles';
import useAuth from '../../features/auth/hooks/useAuth';

const { Text } = Typography;

const Header = (): ReactElement => {
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <HeaderBlock>
      <SiteName>
        <Text strong>架電システム</Text>
      </SiteName>
      <NavigationMenu>
        <NavLink to='/user'>
          <Button type='text'>モニター設定</Button>
        </NavLink>
        <NavLink to='/history'>
          <Button type='text'>履歴</Button>
        </NavLink>
        <NavLink to='/setting/1honbu'>
          <Button type='text'>1本部用設定</Button>
        </NavLink>
        <NavLink to='/setting/2honbu'>
          <Button type='text'>2本部用設定</Button>
        </NavLink>
        <LogoutButton type='text' onClick={handleLogout}>
          ログアウト
        </LogoutButton>
      </NavigationMenu>
    </HeaderBlock>
  );
};

export default Header;
